import { render } from "./RentalMovimentView.vue?vue&type=template&id=4b2f67c1&scoped=true"
import script from "./RentalMovimentView.vue?vue&type=script&lang=js"
export * from "./RentalMovimentView.vue?vue&type=script&lang=js"

import "./RentalMovimentView.vue?vue&type=style&index=0&id=4b2f67c1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2f67c1"]])

export default __exports__